// ABOUTME: React Query hook for overview data
// ABOUTME: Provides loading, error, and data states

import { useQuery } from '@tanstack/react-query'
import { overviewApi } from '@/api/overview'

export const useOverview = () => {
  return useQuery({
    queryKey: ['overview'],
    queryFn: overviewApi.getOverview,
    // Cache for 10 minutes (metrics don't change often)
    staleTime: 10 * 60 * 1000,
  })
}
